/**
 * Client Protected Route
 * Guards routes that require client portal authentication
 */

import { Navigate, useLocation } from 'react-router-dom'
import { useClientSession } from '../hooks/useClientSession'

interface ClientProtectedRouteProps {
  children: React.ReactNode
}

export default function ClientProtectedRoute({ children }: ClientProtectedRouteProps) {
  const { user, loading } = useClientSession()
  const location = useLocation()

  // Show nothing while checking auth (prevents flash)
  if (loading) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        background: '#EFEDE8',
      }}>
        <div style={{
          width: 40,
          height: 40,
          border: '3px solid #E4E1DB',
          borderTopColor: '#C8A45C',
          borderRadius: 0,
          animation: 'spin 1s linear infinite',
        }} />
        <style>{`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    )
  }

  // Not authenticated - redirect to portal login
  if (!user) {
    return <Navigate to="/portal/login" state={{ from: location }} replace />
  }

  // Authenticated - render children
  return <>{children}</>
}
